// extracted by mini-css-extract-plugin
export default {"cta":"cta_cta__1QDvB"};